import { Button } from 'react-bootstrap';
import React, { useState } from 'react';
import CompanyNumberFieldModal from './CompanyNumberFieldModal';
import { EditButton } from '@rd-web-markets/shared/dist/util/buttons';
const CompanyNumberField = _ref => {
  let {
    company,
    setCompanyNumber,
    index
  } = _ref;
  const [modalOpen, setModalOpen] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, company.number && /*#__PURE__*/React.createElement("td", null, company.number, " ", /*#__PURE__*/React.createElement(EditButton, {
    onClick: () => setModalOpen(true)
  })), !company.number && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "sm",
    onClick: () => setModalOpen(true)
  }, "Add Company Number")), modalOpen && /*#__PURE__*/React.createElement(CompanyNumberFieldModal, {
    show: modalOpen,
    onHide: () => setModalOpen(false),
    onSubmit: field => setCompanyNumber(field, index)
  }));
};
export default CompanyNumberField;